var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.6225 65.0333H63.6384C64.3316 65.0333 64.6783 65.0333 64.943 64.8984C65.1759 64.7797 65.3653 64.5903 65.4839 64.3574C65.6188 64.0927 65.6188 63.7461 65.6188 63.0529V28.0246C65.6188 27.3313 65.6188 26.9847 65.4839 26.72C65.3653 26.4871 65.1759 26.2977 64.943 26.1791C64.6783 26.0442 64.3316 26.0442 63.6384 26.0442H43.6955C43.3928 26.0442 43.2414 26.0442 43.0989 26.01C42.9726 25.9796 42.8519 25.9296 42.7412 25.8618C42.6163 25.7852 42.5092 25.6782 42.2951 25.4641L33.708 16.8769C33.4939 16.6628 33.3869 16.5558 33.2619 16.4793C33.1512 16.4114 33.0305 16.3614 32.9042 16.3311C32.7617 16.2969 32.6104 16.2969 32.3076 16.2969H15.6138C14.9206 16.2969 14.574 16.2969 14.3092 16.4318C14.0763 16.5504 13.8869 16.7398 13.7683 16.9727C13.6334 17.2375 13.6334 17.5841 13.6334 18.2773V63.0529C13.6334 63.7461 13.6334 64.0927 13.7683 64.3574C13.8869 64.5903 14.0763 64.7797 14.3092 64.8984C14.574 65.0333 14.9206 65.0333 15.6138 65.0333H26.6297",
    stroke: "#1D98BD",
    strokeWidth: 3.71325,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6261 39.0415L29.8788 48.7888M39.6261 39.0415L49.3734 48.7888M39.6261 39.0415L39.6261 61.7852",
    stroke: "#1D98BD",
    strokeWidth: 3.71325
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderUp);
export default __webpack_public_path__ + "static/media/Folder_up.379980dc3ad90d0959fa51fde686e5d2.svg";
export { ForwardRef as ReactComponent };